/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.unifiedaccount.rpc.AppRpc
 */

export const listSupportedAppsRpc = {
  serviceName: 'com.hubspot.unifiedaccount.rpc.AppRpc',
  rpcName: 'listSupportedApps',
  auth: 'app',
  fingerprint: 'PEFzqXzsoBzmucyFJwYe6iuA_Z2EOXVR',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};